import { useCallback, useEffect, useRef } from 'react'

const CTRL_KEY = 17
const PLUS_KEY = 187
const MINUTE_KEY = 189

export default function useZoom(zoomIn, zoomOut) {
  const isHoldingCrl = useRef(false)

  const onKeyDown = useCallback(
    (evt) => {
      switch (evt.keyCode) {
        case CTRL_KEY:
          isHoldingCrl.current = true
          break
        case PLUS_KEY:
          if (!isHoldingCrl.current) return
          evt.preventDefault() // prevent zoom of browser
          zoomIn()
          break
        case MINUTE_KEY:
          if (!isHoldingCrl.current) return
          evt.preventDefault() // prevent zoom of browser
          zoomOut()
          break
        default:
          break
      }
    },
    [zoomIn, zoomOut]
  )

  const onKeyUp = useCallback((evt) => {
    switch (evt.keyCode) {
      case CTRL_KEY:
        isHoldingCrl.current = false
        break
      default:
        break
    }
  }, [])

  useEffect(() => {
    window.addEventListener('keydown', onKeyDown)
    window.addEventListener('keyup', onKeyUp)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
      window.removeEventListener('keyup', onKeyUp)
    }
  }, [onKeyDown, onKeyUp])
}
